import type { CandleWithFlag } from "features/chart";

export interface FractalChaosBandsLines {
  upper: (number | null)[];
  lower: (number | null)[];
}

export function calcFractalChaosBands(
  data: CandleWithFlag[],
  period: number,
): FractalChaosBandsLines {
  const n = data.length;
  const upFractal = new Array<boolean>(n).fill(false);
  const downFractal = new Array<boolean>(n).fill(false);

  for (let i = period; i < n - period; i++) {
    let isUp = true, isDown = true;
    for (let j = 1; j <= period; j++) {
      if (data[i].high <= data[i - j].high || data[i].high <= data[i + j].high) isUp = false;
      if (data[i].low >= data[i - j].low || data[i].low >= data[i + j].low) isDown = false;
    }
    upFractal[i] = isUp;
    downFractal[i] = isDown;
  }

  const upper: (number | null)[] = new Array(n).fill(null);
  const lower: (number | null)[] = new Array(n).fill(null);
  let lastUp: number | null = null;
  let lastDown: number | null = null;

  for (let i = 0; i < n; i++) {
    if (upFractal[i]) lastUp = data[i].high;
    if (downFractal[i]) lastDown = data[i].low;
    upper[i] = lastUp;
    lower[i] = lastDown;
  }

  return { upper, lower };
}
